




























































import { Vue, Prop, Component } from "vue-property-decorator";
import { SubscriptionFeature, UpgradeSubscriptionPayload } from "../types";
import { namespace } from "vuex-class";
import { AxiosResponse } from "axios";

const Subscription = namespace("subscriptions");

@Component({})
export default class SubscriptionBox extends Vue {
  @Subscription.Action("updateSubscription") upgradeSubscription!: (
    payload: UpgradeSubscriptionPayload
  ) => Promise<{}>;
  @Subscription.Action("getCurrentSubscriptionPlan")
  getCurrentSubscriptionPlan!: () => Promise<AxiosResponse>;
  @Subscription.Action("getCurrentVendorQuota")
  getCurrentVendorQuota!: () => Promise<{}>;
  @Prop({ default: "" }) readonly subscriptionPlanId!: string;
  @Prop({ default: "0" }) readonly verificationPrice!: string;
  @Prop({ default: "Sandbox" }) readonly subcriptionPlanName!: string;
  @Prop({ default: "1,000" }) readonly verificationsPerMonth!: string;
  @Prop({ default: "99" }) readonly subscriptionCost: string;
  @Prop({ default: true }) readonly isSandbox: string;
  @Prop({ default: true }) readonly isCurrentPlan: string;

  features: SubscriptionFeature[];
  loading = false;

  isGrowthOrScale = () =>
    this.subcriptionPlanName === "Growth" ||
    this.subcriptionPlanName === "Scale";

  isScale = () => this.subcriptionPlanName === "Scale";

  created() {
    this.features = [
      {
        id: "liveness-detection",
        name: "Liveness Detection",
        isSandboxFeature: true,
      },
      {
        id: "facial-comparision",
        name: "Facial Comparison",
        isSandboxFeature: true,
      },
      {
        id: "document-authenticity",
        name: "Document Authentication",
        isSandboxFeature: true,
      },
      {
        id: "webhooks-feature",
        name: "Webhook and API Access",
        isSandboxFeature: true,
      },
      {
        id: "automations-checks",
        name: "Automation Checks",
        isSandboxFeature: this.isGrowthOrScale(),
      },
      {
        id: "sdk-ui-customization",
        name: "UI Customization",
        isSandboxFeature: this.isGrowthOrScale(),
      },
      {
        id: "kyb-organization-check",
        name: "KYB Organisation Scan",
        isSandboxFeature: this.isScale(),
      },
      {
        id: "dedicated-support",
        name: "Dedicated Integration Support",
        isSandboxFeature: this.isScale(),
      },
    ];
  }
  goBack() {
    this.$router.push({ name: "subscriptions" });
  }
  async updateSubscriptionPlan() {
    this.loading = true;
    this.upgradeSubscription({
      planId: this.subscriptionPlanId,
    })
      .then(async (result: AxiosResponse) => {
        this.loading = false;
        await this.getCurrentVendorQuota();
        if (result.data) {
          const currentPlanName = result.data.data.subscriptionPlan.name;
          this.$notify({
            group: "success",
            title: "Subscription Updated.",
            text: `<p>You are now currently subscribed to the <b>${currentPlanName}</b> plan</p>`,
          });
        }
      })
      .then(async () => {
        this.loading = false;
        await this.getCurrentSubscriptionPlan();
        await this.getCurrentVendorQuota();
        this.goBack();
      })
      .catch((e) => {
        if (e.response.data.errors[0]) {
          this.$notify({
            group: "error",
            title: "Failed to update subscription.",
            text: `${
              e.response.data.errors[0].message ===
              "An error occurred while creating vendor subscription."
                ? "Failed to upgrade subscription."
                : "An error occurred"
            }`,
          });
        }
        this.loading = false;
      });
  }
}
